var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              staticStyle: { "margin-top": "22px" },
              attrs: { "label-width": "100px" },
            },
            [
              _c("el-form-item", { attrs: { label: "赠品说明" } }, [
                _c("div", {
                  staticClass: "detail",
                  domProps: { innerHTML: _vm._s(_vm.detail.giveawayText) },
                }),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "选择赠品" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "651px" },
                      attrs: {
                        border: "",
                        data: _vm.detail.interestGoods,
                        "header-cell-style": {
                          background: "#F5F6FA",

                          color: "#303033",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "排序",
                          prop: "type",
                          align: "center",
                          width: "80px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v(_vm._s(props.$index + 1))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "商品名称",
                            prop: "type",
                            align: "left",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "left" } },
                                    [_vm._v(_vm._s(props.row.name))]
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v("商品名称")]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: {
                          label: "赠送个数",
                          prop: "type",
                          align: "center",
                          width: "120px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v(_vm._s(props.row.num))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "优惠券说明" } }, [
                _c("div", {
                  staticClass: "detail",
                  domProps: { innerHTML: _vm._s(_vm.detail.couponText) },
                }),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "选择优惠券" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "651px" },
                      attrs: {
                        border: "",
                        data: _vm.detail.interestCoupon,
                        "header-cell-style": {
                          background: "#F5F6FA",

                          color: "#303033",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "排序",
                          prop: "type",
                          align: "center",
                          width: "80px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v(_vm._s(props.$index + 1))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "优惠券名称",
                            prop: "type",
                            align: "left",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "left" } },
                                    [_vm._v(_vm._s(props.row.name))]
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v("优惠券名称")]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: {
                          label: "赠送张数",
                          prop: "type",
                          align: "center",
                          width: "120px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v(_vm._s(props.row.num))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "back-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }